export default __webpack_public_path__ + "static/media/frente2.21612aab.jpg";